import NotFooterLayout from "layouts/NotFooterLayout";
import CreditTopupCheckoutPage from "components/ManageCredit/CreditTopupCheckoutPage";

function ManageCreditTopupCheckoutPage() {
  return (
    <NotFooterLayout namePage="ชำระเงิน">
      <div className="layout-content">
        <CreditTopupCheckoutPage />
      </div>
    </NotFooterLayout>
  );
}

export default ManageCreditTopupCheckoutPage;
